module.exports = __webpack_public_path__ + "static/media/arrow-right-blue.c80b4f09.svg";